export const toggleColorModeStyles = (isDark: boolean, isDownMd: boolean) => ({
  container: {
    display: 'flex',
    width: 'auto',
    justifyContent: isDownMd ? 'flex-start' : 'flex-end',
    color: isDark ? 'primary.main' : 'primary.main',
    pr: isDownMd ? 0 : 1.25,
    '& svg': {
      width: 18,
      height: 18
    }
  },
  ball: { borderRadius: '25px' }
});
